import { useContext } from "react";
import { IContextValueProvider } from "sonobello.utilities.react";

import { SessionContext, SessionContextProps } from "../../../Context/SessionContext";
import { UserContext, UserContextProps } from "../../../Context/UserContext";

/**
 * An {@link IContextValueProvider} which obtains its properties from both  {@link SessionContext} and
 * {@link UserContext}.
 * @typeParam TFulfilledProps - The type which is returned by the context mapping.
 * @typeParam TComponent - The type which encompasses the values fulfilled by the provider.
 */
function ContextValueProvider<TFulfilledProps, TComponent extends TFulfilledProps>({
  Component,
  map
}: IContextValueProvider<SessionContextProps & UserContextProps, TFulfilledProps, TComponent>): React.FC<
  Omit<TComponent, keyof TFulfilledProps>
> {
  return componentProps => {
    const sessionContextProps = useContext(SessionContext);
    const userContextProps = useContext(UserContext);
    return Component({ ...componentProps, ...map({ ...sessionContextProps, ...userContextProps }) } as TComponent);
  };
}

export default ContextValueProvider;
